module.exports = __webpack_public_path__ + "img/profile_box_gray_position.85ae2ece.svg";